import ErrorBoundary from '@nobia/zeus-components/lib/errorBoundary'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import React, { Suspense, createElement } from 'react'

import Loader from '../loader/Loader'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`
const ContentWrapper = styled.div`
  flex-grow: 1;
`

const Page = ({ children, loading }) => {
  const parsedChildren =
    typeof children === 'function' ? createElement(children) : children
  return (
    <Wrapper>
      <ContentWrapper>
        <Suspense fallback={<Loader />} />
        <ErrorBoundary name="page">
          {loading ? <Loader /> : parsedChildren}
        </ErrorBoundary>
      </ContentWrapper>
    </Wrapper>
  )
}

Page.defaultProps = {
  loading: false,
}

Page.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  loading: PropTypes.bool,
}

export default Page
